// extracted by mini-css-extract-plugin
export default {"filter-group":"FilterGroup_filter-group__Qqb2s","filter-group-vertical":"FilterGroup_filter-group-vertical__yo5e5"};